import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MigBoardLeftMenu } from '@home/components/YWK_MigBoard'

export enum CurPage {
    article = 0,
    comment = 1,
    recentView = 2,
}

@Component({
    components: { MigBoardLeftMenu },
})
export default class YWK_MigBoardLeftMenuContainer extends Vue {
    @Prop({type: Number }) selectedMenuId!:number
    @Prop({type: Array }) boardList!:ywkMigration.board[]
}
